import S, { DataSignal } from 's-js';

/**
 * Wraps the provided signal such that attempted writes are ignored unless they satisfy the
 * provided filter (i.e. the filter returns a truthy value).
 */
export function filterWrites<T>(signal : DataSignal<T>, filter : (incoming : T, current : T) => unknown) : DataSignal<T>;
export function filterWrites<T, S extends T>(signal : DataSignal<S>, filter : (incoming : T, current : S) => incoming is S) : DataSignal<T>;
export function filterWrites<T>(signal : DataSignal<T>, filter : (incoming : T, current : T) => unknown) {
    return function (incoming : T) {
        let current : T;
        return (
            arguments.length === 0 ? signal() :
            filter(incoming, current = S.sample(signal)) ? signal(incoming) :
            current
        );
    };
}



// WEBPACK FOOTER //
// ./lib/filterSignalWrites.ts